module.exports = __webpack_public_path__ + "main/assets/fonts/scoville/scoville.woff";


//////////////////
// WEBPACK FOOTER
// ./main/assets/fonts/scoville/scoville.woff
// module id = 1282
// module chunks = 0